import { flightTypes, workplaceTypes } from "../types";
import {  ArrivalFlightChecklistBlock, DepartureFlightChecklistBlock } from "../FlightBlock/ChecklistBlock";
import { modalContainerWarningCheckList } from "@/Modal/ModalContainerWarningCheckList"

import { isEnabledMsg, isUnreadMsg } from "@/utils.js";
import { HeaderMenuBlock } from '../Block/HeaderMenuBlock/HeaderMenuBlock'
import { VehicleNumberBlock } from "../Block/VehicleNumberBlock";
import { appNotification } from '@/components/AppNotification.js'
import { storage } from "@/components/Storage";
import { user } from "@/components/User";
import { interval } from '@/components/Interval.js';
import { loader } from '@/components/Loader.js';
import { server } from '@/components/Server.js';
import { flightMenuBlock } from '@/Block/FlightMenuBlock.js';

export const taskFlightCheckListPage = {
    errCheckList: null,
    controller: function () {
        //return;
        var self = this;
        self.errCheckList = "";

        if (!user.exists()) {
            m.route('/login');
            return;
        }

        interval.clearAll();

        loader.show();

        if (user.get('state.workplace') === workplaceTypes.driver) {
            this.topMenu = [
                { title: 'Задачи', url: '/vehicle/tasks', icon: 'fa-tasks' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];

            if (user.get('state.vehicleFreeTasksAvailable')) {
                this.topMenu.unshift(
                    { title: 'Свободные', url: '/vehicle/tasks/free', icon: 'fa-car' }
                )
            }
        } else if (user.get('state.workplace') === workplaceTypes.agent) {
            this.topMenu = [
                { title: 'Задачи', url: '/agent/tasks', icon: 'fa-tasks' },
                { title: 'Рейсы', url: '/agent/flights', icon: 'fa-plane' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];
        } else {
            this.topMenu = [
                { title: 'Задачи', url: '/', icon: 'fa-tasks' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];
        }

        this.data = m.request({
            method: 'GET',
            url: '/api/task/' + m.route.param('taskId') + '/checklist'
        }).then(function (response) {
            server.setOnline();
            loader.hide();
            storage.config = response.config;

            if(response.checkList.length == 0) {
                taskFlightCheckListPage.errCheckList = "Чек-лист не создан!";
            }
            else if(response.checkList == 1) {
                taskFlightCheckListPage.errCheckList = "Чек-лист не создан!";
            }
            else if (response.checkList == 2) {
                taskFlightCheckListPage.errCheckList = "Борт не назначен!";
            }
            appNotification.list = response.notifications;

            server.initPing();
            appNotification.init();

            return response;
        }, function (response) {
            if (response && response.message) {
                self.errmsg = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });

        let el = document.querySelector("#Audit");
        if(el)
            el.parentNode.removeChild(el);
    },
    view: function (ctrl) {
        return [
            m.component(HeaderMenuBlock, {
                time: ctrl.data().time,
                menu: ctrl.topMenu
            }),
            m("div[style='margin-top:0px']", [
                VehicleNumberBlock(),
                m.component(flightMenuBlock, {
                    board: ctrl.data().board,
                    menu: ctrl.data().menu,
                    tasks: ctrl.data().tasks,
                    currentTask: ctrl.data().currentTask,
                    tab: 'info'
                })
            ]),
            ctrl.errmsg,
            //modalContainerWarningCheckList.init(),
            (taskFlightCheckListPage.errCheckList != null) ?  modalContainerWarningCheckList.open(taskFlightCheckListPage.errCheckList) : [
                ctrl.data().checkList == 2 || ctrl.data().checkList == 1 ? [] : [
                    Array.isArray(ctrl.data().checkList) ?
                        m(".container[id='container'][style='padding-top:10px']", [
                            m(".container[id='buttonsContainer'][style='padding-top:10px']", [
                                m(".row", [
                                    m(".col-xs-6[style='padding:0 5px 0 10px']", [
                                        //m("span", "Дата"),
                                        m("button.btn.btn-block.block-arrival[style='border-radius: 5px;'][id='buttonTurnaround1']", {
                                            onclick: function (e) {
                                                if (ctrl.data().checkList[0] == 1)
                                                    modalContainerWarningCheckList.open("Чек лист отсутствует!"); //alert("Чек лист отсутствует!");
                                                else if (ctrl.data().checkList[0] == 2)
                                                    modalContainerWarningCheckList.open("Борт не назначен!"); //alert("Борт не назначен!");
                                                else {
                                                    let pv = 0;
                                                    if (ctrl.data().checkList[0].PV != 'П')
                                                        pv = 1;

                                                    localStorage.setItem("info", JSON.stringify(ctrl.data().info[pv]));
                                                    localStorage.setItem("checkList", JSON.stringify(ctrl.data().checkList[pv]));
                                                    localStorage.setItem("turnaround", JSON.stringify(ctrl.data().turnaround[pv]));

                                                    if (ctrl.data().checkList[pv]["factBeginAudit"] == null) {
                                                        loader.show();
                                                        m.request({
                                                            method: 'PUT',
                                                            url: '/api/task/logCreateAudit',
                                                            data: JSON.stringify(ctrl.data().checkList[pv])
                                                        }).then(function (response) {
                                                            loader.hide();

                                                            let audit = document.createElement('div');
                                                            audit.id = 'Audit';
                                                            let app = document.querySelector("#container");

                                                            app.appendChild(audit);

                                                            m.mount(
                                                                audit,
                                                                m.component(ArrivalFlightChecklistBlock, {
                                                                    data: JSON.parse(localStorage.getItem("info")),
                                                                    checkList: response,
                                                                    turnaround: JSON.parse(localStorage.getItem("turnaround"))
                                                                    //showBookingBlock: ctrl.data().config.openSkyBlocksShow
                                                                })
                                                            );

                                                            let el = document.querySelector("#buttonsContainer");
                                                            el.parentNode.removeChild(el);

                                                            m.redraw.strategy("diff");

                                                        }, function () {
                                                            loader.hide();
                                                        });
                                                    } else {
                                                        let audit = document.createElement('div');
                                                        audit.id = 'Audit';
                                                        let app = document.querySelector("#container");

                                                        app.appendChild(audit);

                                                        m.mount(
                                                            audit,
                                                            m.component(ArrivalFlightChecklistBlock, {
                                                                data: ctrl.data().info[pv],
                                                                checkList: ctrl.data().checkList[pv],
                                                                turnaround: ctrl.data().turnaround[pv],
                                                                showBookingBlock: ctrl.data().config.openSkyBlocksShow
                                                            })
                                                        );

                                                        let el = document.querySelector("#buttonsContainer");
                                                        el.parentNode.removeChild(el);

                                                        m.redraw.strategy("diff");
                                                    }
                                                }
                                            }
                                        }, "Чек-лист прилета")
                                    ]),
                                    m(".col-xs-6[style='padding:0 10px 0 5px']", [
                                        //m("span", "№ Рейса"),
                                        m("button.btn.btn-block.block-departure[style='border-radius: 5px;'][id='buttonTurnaround2']", {
                                            onclick: function () {

                                                if (ctrl.data().checkList[0] == 1)
                                                    modalContainerWarningCheckList.open("Чек лист отсутствует!"); //alert("Чек лист отсутствует!");
                                                else if (ctrl.data().checkList[0] == 2)
                                                    modalContainerWarningCheckList.open("Борт не назначен!"); //alert("Борт не назначен!");
                                                else {
                                                    let pv = 1;
                                                    if (ctrl.data().checkList[0].PV != 'П')
                                                        pv = 0;

                                                    localStorage.setItem("info", JSON.stringify(ctrl.data().info[pv]));
                                                    localStorage.setItem("checkList", JSON.stringify(ctrl.data().checkList[pv]));
                                                    localStorage.setItem("turnaround", JSON.stringify(ctrl.data().turnaround[pv]));


                                                    if (ctrl.data().checkList[pv]["factBeginAudit"] == null) {
                                                        loader.show();
                                                        m.request({
                                                            method: 'PUT',
                                                            url: '/api/task/logCreateAudit',
                                                            data: JSON.stringify(ctrl.data().checkList[pv])
                                                        }).then(function (response) {
                                                            loader.hide();

                                                            let audit = document.createElement('div');
                                                            audit.id = 'Audit';
                                                            let app = document.querySelector("#container");

                                                            app.appendChild(audit);

                                                            m.mount(
                                                                audit,
                                                                m.component(DepartureFlightChecklistBlock, {
                                                                    data: JSON.parse(localStorage.getItem("info")),
                                                                    checkList: response,
                                                                    turnaround: JSON.parse(localStorage.getItem("turnaround"))
                                                                    //showBookingBlock: ctrl.data().config.openSkyBlocksShow
                                                                })
                                                            );

                                                            let el = document.querySelector("#buttonsContainer");
                                                            el.parentNode.removeChild(el);

                                                            m.redraw.strategy("diff");

                                                        }, function () {
                                                            loader.hide();
                                                        });
                                                    } else {
                                                        let audit = document.createElement('div');
                                                        audit.id = 'Audit';
                                                        let app = document.querySelector("#container");

                                                        app.appendChild(audit);

                                                        m.mount(
                                                            audit,
                                                            m.component(DepartureFlightChecklistBlock, {
                                                                data: ctrl.data().info[pv],
                                                                checkList: ctrl.data().checkList[pv],
                                                                turnaround: ctrl.data().turnaround[pv],
                                                                showBookingBlock: ctrl.data().config.openSkyBlocksShow
                                                            })
                                                        );

                                                        let el = document.querySelector("#buttonsContainer");
                                                        el.parentNode.removeChild(el);

                                                        m.redraw.strategy("diff");
                                                    }
                                                }
                                            }
                                        }, "Чек-лист вылета")
                                    ])
                                ])
                            ])
                        ]) :
                        ctrl.data().checkList == 1 || ctrl.data().checkList == 2 ? [
                                ctrl.data().checkList == 2 ? [
                                        m(".row", [
                                            m(".col-xs-12.text-center[style='padding:7px']", [
                                                m("[style='font-size:16px']", "Борт не назначен"),
                                            ])
                                        ]) ] :
                                    ctrl.data().checkList == 1 ?
                                        m(".row", [
                                            m(".col-xs-12.text-center[style='padding:7px']", [
                                                m("[style='font-size:16px']", "Чек-лист отсутствует"),
                                            ])
                                        ]) : []
                            ] :
                            [
                                ctrl.data().info.type === flightTypes.departure ?
                                    m.component(DepartureFlightChecklistBlock, {
                                        data: ctrl.data().info,
                                        checkList: ctrl.data().checkList,
                                        turnaround: ctrl.data().turnaround,
                                        showBookingBlock: ctrl.data().config.openSkyBlocksShow
                                    }) :
                                    m.component(ArrivalFlightChecklistBlock, {
                                        data: ctrl.data().info,
                                        checkList: ctrl.data().checkList,
                                        turnaround: ctrl.data().turnaround,
                                        showBookingBlock: ctrl.data().config.openSkyBlocksShow
                                    })
                            ]
                ]
            ],
            ctrl.data().checkList == 1 || ctrl.data().checkList == 2 ? [
                ctrl.data().checkList == 2 ? [
                        m(".row", [
                            m(".col-xs-12.text-center[style='padding:7px']", [
                                m("[style='font-size:16px']", "Борт не назначен"),
                            ])
                        ]) ] :
                    ctrl.data().checkList == 1 ?
                        m(".row", [
                            m(".col-xs-12.text-center[style='padding:7px']", [
                                m("[style='font-size:16px']", "Чек-лист отсутствует"),
                            ])
                        ]) : []
            ] : []
        ];
        // return
    }
};
